export const UI_THEME_CURRENT = 'current';
export const UI_THEME_TAILADMIN = 'tailadmin';
export const UI_THEME_FLIGHTOPS = 'flightops';

export const UI_THEMES = Object.freeze([
  {
    id: UI_THEME_CURRENT,
    name: 'Current GlobalOps',
    description: 'The existing GlobalOps visual design.',
  },
  {
    id: UI_THEME_TAILADMIN,
    name: 'GlobalOps TailAdmin',
    description: 'The new Figma-based operational design system.',
  },
  {
    id: UI_THEME_FLIGHTOPS,
    name: 'FlightOps Brand',
    description: 'The FlightOps.io brand language adapted for the operational application.',
  },
]);

const STORAGE_KEY = 'globalops.ui-theme';
const CHANGE_EVENT = 'globalops:ui-theme-change';

export function normalizeUiTheme(value) {
  return value === UI_THEME_TAILADMIN || value === UI_THEME_FLIGHTOPS
    ? value
    : UI_THEME_CURRENT;
}
export function getUiTheme() {
  if (typeof window === 'undefined') return UI_THEME_CURRENT;
  return normalizeUiTheme(window.localStorage.getItem(STORAGE_KEY));
}

export function applyUiTheme(value, { persist = true } = {}) {
  const theme = normalizeUiTheme(value);
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.uiTheme = theme;
  }
  if (typeof window !== 'undefined') {
    if (persist) window.localStorage.setItem(STORAGE_KEY, theme);
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { theme } }));
  }
  return theme;
}

export function initializeUiTheme() {
  return applyUiTheme(getUiTheme(), { persist: false });
}

export function subscribeUiTheme(listener) {
  if (typeof window === 'undefined') return () => {};
  const handler = (event) => listener(normalizeUiTheme(event.detail?.theme));
  window.addEventListener(CHANGE_EVENT, handler);
  return () => window.removeEventListener(CHANGE_EVENT, handler);
}
